import React, { useState, useEffect } from 'react';

export default ({ data, hide, itemActive }) => {
	//console.log('dataaa',data);

	data.isShown = data.id === itemActive ? true : false;

	return (
		<div className="card" onClick={() => hide(data.id)}>
			<div className="card-header" id="headingOne">
				<h5 className="mb-0">
					<button
						className="btn btn-link"
						data-toggle="collapse"
						data-target="#collapseOne"
						aria-expanded="true"
						aria-controls="collapseOne"
					>
						{data && data.ville}
					</button>
				</h5>
			</div>

			<div
				id="collapseOne"
				className={'collapse ' + (data.isShown ? 'show' : '')}
				aria-labelledby="headingOne"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="col-md-4">
						<span className="name">{data && data.responsable}</span>
						<span className="metier">{data && data.profil}</span>
					</div>
					<div className="col-md-8">
						<ul>
							<li className="adresse">
								<label>Adresse</label>
								<span>{data && data.adresse}</span>
								<a
									target="_BLANCK"
									className="localisation"
									href={'https://www.google.com/maps/?q=' + data.latitude + ',' + data.longitude}
								>
									Localisation sur Google Maps
								</a>
							</li>
							<li className="gsm">
								<label>GSM</label>
								<span>{data && data.GSM}</span>
							</li>
							<li className="tel">
								<label>Tél</label>
								<span>{data && data.telephone}</span>
							</li>
							<li className="mail">
								<label>Email</label>
								<span>
									<a href={'mailto:' + data.email}>{data && data.email}</a>
								</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};
